"use client";

import { Config } from "@/shared/config";
import Script from "next/script";

const script = `
window.plausible = window.plausible || function() {
    (window.plausible.q = window.plausible.q || []).push(arguments);
};
`;

const config = {
  domain: Config.domainName,
  script:
    "https://analytics3.ricu.it/js/script.file-downloads.hash.outbound-links.pageview-props.revenue.tagged-events.js",
};

export const Analytics = () => {
  return (
    <>
      <Script defer data-domain={config.domain} src={config.script} />
      <Script
        id="plausible-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: script,
        }}
      />
    </>
  );
};
